
<template>
  <div class="materialNumList">
    <el-container>
      <el-header>
        <el-form ref="form" :model="form" label-width="60px" :inline="true">
          <el-row>
            <el-col :span="6">
              <el-form-item label="存货名称" prop="productName">
                <el-input
                  v-model="form.productName"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="存货编码" prop="productNumber">
                <el-input
                  v-model="form.productNumber"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="5">
              <el-form-item label="细目编码" prop="num111">
                <el-input v-model="form.num111" autocomplete="off"></el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="6">
              <el-form-item label="类型" prop="isAdmin">
                <el-select v-model="form.isAdmin">
                  <el-option label="材料" :value="0"></el-option>
                  <!-- <el-option label="否" :value="0"></el-option> -->
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <div class="handlePanel">
                <el-button type="primary" @click="selectClick()"
                  >查询</el-button
                >
                <el-button type="info" @click="resetClick()">重置</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>

        <div style="clear: both"></div>
        <el-row>
          <el-col :span="24">
            <div class="handlePanel">
              <el-button
                type="primary"
                icon="el-icon-download"
                @click="downTemplate()"
                v-if="btnAuthorize.downloadTemplate.btnEnable"
                >下载模板</el-button
              >
              <el-button
                type="primary"
                icon="el-icon-upload2"
                @click="importProjectList()"
                v-if="btnAuthorize.import.btnEnable"
                >导入</el-button
              >
              <el-button
                type="primary"
                icon="el-icon-download"
                @click="exportCurrentList()"
                v-if="btnAuthorize.export.btnEnable"
                >导出</el-button
              >
            </div>
          </el-col>
        </el-row>
      </el-header>
      <el-main ref="main">
        <el-table
          ref="dataTable"
          :data="materialNumList"
          highlight-current-row
          size="mini"
          height="100%"
          @selection-change="handleSelectionChange"
          @row-click="rowClicked"
          @cell-dblclick="subCategoryDetail"
          border
        >
          <el-table-column
            type="index"
            width="50"
            label="序号"
          ></el-table-column>
          <el-table-column
            prop="productNumber"
            label="存货编码"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="productName"
            label="存货名称"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column label="类型" :show-overflow-tooltip="true"
            >材料</el-table-column
          >
          <el-table-column
            prop="model"
            label="规格型号"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="factoryName"
            label="厂商"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="unit"
            label="计量单位"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="unitPrice"
            label="单价"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span>{{ scope.row[scope.column.property] | numFilter }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="remarks"
            label="备注"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column label="操作" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="mini"
                @click="updBtnPressed(scope.row)"
                v-if="btnAuthorize.modifyBtn.btnEnable"
                >修改</el-button
              >
              <el-button
                type="text"
                size="mini"
                @click="delBtnPressed(scope.row)"
                v-if="btnAuthorize.delBtn.btnEnable"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageIndex"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, prev, pager, next, sizes, jumper"
          :total="total"
        ></el-pagination>
      </el-footer>
    </el-container>

    <!--修改工程量清单弹窗 -->
    <el-dialog
      width="600px"
      :title="isAdd ? '详情' : '修改'"
      :visible.sync="isAddDialogShow"
      :before-close="closeAddDialog"
      :close-on-click-modal="false"
    >
      <el-form
        ref="addForm"
        :model="addForm"
        label-width="120px"
        :rules="addRules"
      >
        <el-row>
          <el-col :span="20">
            <el-form-item label="存货编码" prop="productNumber">
              <el-input
                v-model="addForm.productNumber"
                autocomplete="off"
                readonly
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="存货名称" prop="productName">
              <el-input
                v-model="addForm.productName"
                autocomplete="off"
                :readonly="isAdd"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="类型">
              <el-select v-model="addForm.isAdmin" :disabled="isAdd">
                <el-option label="材料" :value="0"></el-option>
                <!-- <el-option label="否" :value="0"></el-option> -->
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="规格型号" prop="model">
              <el-input
                v-model="addForm.model"
                autocomplete="off"
                :readonly="isAdd"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="厂商" prop="factoryName">
              <el-input
                v-model="addForm.factoryName"
                autocomplete="off"
                :readonly="isAdd"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="计量单位" prop="unit">
              <el-input
                v-model="addForm.unit"
                autocomplete="off"
                :readonly="isAdd"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="单价">
              <el-input
                v-model="addForm.unitPrice"
                autocomplete="off"
                :readonly="isAdd"
                @keyup.native="checkAmount(1)"
                @blur="Fornmat(1)"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="备注" prop="remarks">
              <el-input
                v-model="addForm.remarks"
                autocomplete="off"
                :readonly="isAdd"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="closeAddDialog" v-if="!isAdd"
          >取 消</el-button
        >
        <el-button type="primary" @click="saveBtnPressed()" v-if="!isAdd"
          >保 存</el-button
        >
        <el-button type="info" @click="closeAddDialog" v-if="isAdd"
          >关 闭</el-button
        >
      </div>
    </el-dialog>

    <!-- 导入物资清单字典 -->
    <upload-dialog
      :isShow="showUploadDialog"
      @close="closeDialogAction"
      :isImportContract="isImportContractDialog"
      @saveImportItems="saveImportItems"
    />
  </div>
</template>

<script>
import {
  exportmaterialDetailsDictList, //导出物资采购字典
  getmaterialDetailsListService, //获取物资采购清单
  updateMaterialDetailsDictService,
  deleteMaterialDetailsDictSevice,
  getTemplate, //下载导入模板
  exportExcelService2, //导出
} from "../../services/allContractServices";
import { numFilter } from "@/utils/filters";
import UploadDialog from "./commonCell/UploadDialog"; //导入工程量清单字典

export default {
  name: "materialNumList",
  components: {
    UploadDialog,
  },
  data() {
    return {
      total: 0, //角色总数
      materialNumList: [], //可选组织列表
      isAddDialogShow: false, //新增弹窗显示开关
      isAdd: false, //true新增 false修改角色标识
      showUploadDialog: false, //导入工程量清单对话框可见性
      isImportContractDialog: false, //标记为导入工程量清单 false 导入物资采购
      menuRoleCode: "", //授权菜单的roleCode
      pageIndex: 1,
      pageSize: 20,
      showAdvanceFilter: false, //是否展开高级搜索
      form: {
        productNumber: "", //子目号
        productName: "", //子目名称
        pageIndex: 1,
        pageSize: 20,
        isAdmin: 0, //类型
      },

      addForm: {
        productNumber: "", //子目号
        productName: "", //子目名称
        unit: "", //单位
        unitPrice: 0, //单价
        remarks: "", //备注
        isAdmin: 0, //类型
      },
      addRules: {
        productNumber: [
          { required: true, message: "请输入存货编码" },
          // { min: 1, max: 20, message: "输入内容长度必须介于1到20之间" }
        ],
        namproductName: [
          { required: true, message: "请输入存货名称" },
          // { min: 1, max: 20, message: "输入内容长度必须介于1到20之间" }
        ],
        unit: [
          { required: true, message: "请输入计量单位" },
          // { min: 1, max: 20, message: "输入内容长度必须介于1到20之间" }
        ],
        unitPrice: [
          // { required: true, message: "请输入单价" },
          {
            pattern: /^[0-9,.]+$/,
            message: "只能输入数字",
          },
          // { min: 1, max: 20, message: "输入内容长度必须介于1到20之间" }
        ],
        remarks: [{ min: 1, max: 60, message: "备注长度必须介于1到60之间" }],
        // type: [{required: true, message: "请选择角色类型"}]
        // deptCode: [{ required: true, message: "请选择组织" }]
      },

      //按钮权限
      btnAuthorize: {
        modifyBtn: { key: "update", btnEnable: false }, //修改
        delBtn: { key: "delete", btnEnable: false }, //删除
        import: { key: "import", btnEnable: false }, //导入
        export: { key: "export", btnEnable: false }, //导出
        downloadTemplate: { key: "downloadTemplate", btnEnable: false }, //下载模板
        // userBtn: { key: "2017111014583055253", btnEnable: false }
      },
    };
  },
  props: {
    menuCode: {
      type: String,
    },
  },
  created() {},
  methods: {
    //激活时调用
    onActive(menuCode) {
      this.$getRoleBtns(menuCode, this.btnAuthorize);
      // this.pageIndex = 1;
      // this.pageSize = 20;
      // this.initList();
    },
    /* 查询按钮回调 */
    selectClick() {
      this.form.pageIndex = 1;
      this.initList();
    },
    /* 重置按钮回调 */
    resetClick() {
      this.$refs.form.resetFields();
      this.initList();
    },
    //获取列表
    initList() {
      // let param = {
      //   // userId: sessionStorage.getItem("userCode"),
      //   pageIndex: this.pageIndex,
      //   pageSize: this.pageSize
      // };
      getmaterialDetailsListService(this.form)
        .then((res) => {
          if (res.code == 10000000) {
            this.materialNumList = res.data;
            this.total = res.total;
          } else {
            if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          }
        })
        .catch((error) => {
          this.$message.error("系统异常");
        });
    }, //
    /* 分页改变事件 */
    handleCurrentChange(page) {
      console.log(page);
      this.form.pageIndex = page;
      this.initList();
    },
    /* 分页显示数量改变事件 */
    handleSizeChange(rows) {
      this.form.pageSize = rows;
      this.form.pageIndex = 1;
      this.initList();
    },

    //下载工程量清单字典模板
    downTemplate() {
      let category = "MATERIAL_DETAILS_BASE"; //工程量清单模板

      getTemplate(category).then(
        (res) => {
          console.log(res);
          if (res.code == 10000000) {
            exportExcelService2(res.data).then((res1) => {
              // this.$alert("成功", "提示", {
              //   confirmButtonText: "确定"
              // });
            });
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          this.$message.error("系统异常");
        }
      );
    },
    /* 导入工程量清单*/
    importProjectList() {
      this.isImportContractDialog = false;
      this.showUploadDialog = true;
    },

    //保存导入的物资清单清单
    saveImportItems(selectItems) {
      this.form.pageIndex = 1;
      this.initList();
    },
    /* 导出工程量清单字典 */
    exportCurrentList() {
      exportmaterialDetailsDictList()
        .then((res) => {
          if (res.code == 10000000) {
            exportExcelService2(res.data).then((res1) => {
              this.$alert("导出成功", "提示", {
                confirmButtonText: "确定",
              });
            });
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch(() => {});
    },
    assignBtnPressed() {
      if (this.roleSelectedList.length != 1) {
        this.$alert("每次只能选择一条记录进行修改！", "提示");
      } else {
        this.menuRoleCode = this.roleSelectedList[0].id;
        this.$refs.RoleMenuAssignDialog.refreshMenu(this.menuRoleCode);
      }
    },
    accountAssignPressed() {
      if (this.roleSelectedList.length != 1) {
        this.$alert("每次只能选择一条记录进行修改！", "提示");
      } else {
        this.menuRoleCode = this.roleSelectedList[0].roleCode;
        this.$refs.RoleAccountAssignDialog.refreshAccount(this.menuRoleCode);
      }
    },
    closeAddDialog() {
      this.$refs.addForm.resetFields();
      this.isAddDialogShow = false;
    },
    /* 弹窗保存按钮回到 */
    saveBtnPressed() {
      this.$refs.addForm.validate((res) => {
        if (res) {
          if (this.isAdd) {
            this.addRow();
          } else {
            this.modifyRow();
          }
        }
      });
    },
    /* 修改信息 */
    modifyRow() {
      // this.addForm.updateUserId = sessionStorage.getItem("currentUserId");
      let data = { ...this.addForm };
      if (data.unitPrice) {
        data.unitPrice = data.unitPrice.toString().replace(/,/g, "");
      }else{
        data.unitPrice =0
      }
      updateMaterialDetailsDictService(data).then(
        (res) => {
          console.log(res);
          if (res.code == 10000000) {
            this.$alert("修改成功", "提示");
            this.isAddDialogShow = false;
            this.initList();
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          this.$message.error("网络请求失败");
        }
      );
    },
    /* 列表多选回调 */
    handleSelectionChange(roleList) {
      this.roleSelectedList = roleList;
    },
    // 点击选中行
    rowClicked(row, event, column) {
      this.$refs.dataTable.toggleRowSelection(row);
    },
    //双击查看该项详情
    subCategoryDetail(row, column, cell, event) {
      this.isAdd = true; //true为查看详情
      this.isAddDialogShow = true;
      this.$nextTick(() => {
        this.addForm = Object.assign({}, row);
        this.addForm.isAdmin = 0;
        this.addForm.unitPrice = numFilter(this.addForm.unitPrice)||0;
      });
    },
    /* 修改按钮回调 */
    updBtnPressed(row) {
      this.isAdd = false;
      this.isAddDialogShow = true;
      this.$nextTick(() => {
        this.addForm = Object.assign({}, row);
        this.addForm.isAdmin = 0;
        this.addForm.unitPrice = numFilter(this.addForm.unitPrice)||0;
      });
    },
    /* 删除按钮回调 */
    delBtnPressed(row) {
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        // let roles = [];
        // this.roleSelectedList.forEach(role => {
        //   roles.push(role.roleId);
        // });
        let rowId = row.id;
        this.delMaterial(rowId);
      });
    },
    /* 删除一条信息 */
    delMaterial(rowId) {
      let reqParam = {
        // userCode: sessionStorage.getItem("userCode"),
        id: rowId,
      };
      deleteMaterialDetailsDictSevice(reqParam).then(
        (res) => {
          console.log(res);
          if (res.code == 10000000) {
            this.$alert("删除成功", "提示");
            this.isAddDialogShow = false;
            this.initList();
          } else if (res.code >10000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
              customClass: "msgbox",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          this.$message.error("网络请求失败");
        }
      );
    },
    //关闭修改对话框
    closeAddDialog() {
      this.$refs.addForm.resetFields();
      this.isAddDialogShow = false;
    },
    //格式化金额
    checkAmount(val) {
      if (val == 1 && this.addForm.unitPrice) {
        //材料单价
        this.addForm.unitPrice = (this.addForm.unitPrice + "").replace(
          /^\D*([,\d]*(?:\.\d{0,2})?).*$/g,
          "$1"
        );
        // this.addForm.amount = numFilter(this.addForm.amount);
      }
    },
    Fornmat(val) {
      if (val == 1) {
        //材料单价
        this.addForm.unitPrice = numFilter(this.addForm.unitPrice);
      } else {
        this.addForm.unitPrice = numFilter(this.addForm.unitPrice);
      }
    },
    //关闭导入对话框
    closeDialogAction() {
      this.showUploadDialog = false;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";
.materialNumList {
  height: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
}
.screenPanel {
  text-align: left;
  min-height: 40px;
  padding: 16px 0 0 0;
}
.handlePanel {
  text-align: right;
  // padding: 0 20px;
}
.el-select {
  width: 100%;
}
.el-form-item__label {
  text-align: left;
}
.el-footer {
  text-align: right;
}
/deep/.el-radio-button__inner {
  background: #d5e7ed;
  border: none;
  border-radius: 0;
  box-shadow: none;
  :hover {
    background: #069dbc;
    color: #fff;
  }
}
/deep/.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background: #fff;
  color: #069dbc;
  border: none;
  border-radius: 0;
  box-shadow: none;
  :hover {
    background: #069dbc;
    color: #fff;
  }
}
</style>
